import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=3ed63fd5&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=3ed63fd5&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed63fd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/clients/client11/web18/web/api/releases/20220610210856/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed63fd5')) {
      api.createRecord('3ed63fd5', component.options)
    } else {
      api.reload('3ed63fd5', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=3ed63fd5&scoped=true&", function () {
      api.rerender('3ed63fd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/src/components/shared/Loader.vue"
export default component.exports